"use client";

import { useEffect, useRef, useState } from "react";
import AudioPlayer from "./audio-player";
import { currentPlayingAtom, showPlayerAtom } from "@/atoms/player";
import { useAtom } from "jotai";
import { User } from "@/lib/user";
import { usePathname } from "next/navigation";

const Player = ({ user }: { user: User }) => {
  const [isMounted, setIsMounted] = useState(false);
  const [showPlayer, setShowPlayer] = useAtom(showPlayerAtom);
  const [current, setCurrent] = useAtom(currentPlayingAtom);
  const [isExpanded, setIsExpanded] = useState(false);
  const isProUser = user?.subscriptionStatus === "active";
  const pathname = usePathname();

  const audioRef = useRef<HTMLAudioElement>(null);

  // Check if we're on a bite page
  const isBitePage = pathname?.startsWith("/bite/");

  useEffect(() => {
    setIsMounted(true);
  }, []);

  const handleClose = () => {
    setShowPlayer(false);
    setIsExpanded(false);
  };

  if (!isMounted || !showPlayer) {
    return null;
  }

  // On bite pages, the player will be rendered inside table-of-contents
  // So we render a marker component that table-of-contents can detect
  if (isBitePage) {
    return null;
  }

  return (
    <div
      className="fixed bottom-4 left-1/2 transform -translate-x-1/2 z-[500] px-4"
      onClick={(e) => e.stopPropagation()}
    >
      <AudioPlayer
        current={current}
        audioRef={audioRef}
        isProUser={isProUser}
        isExpanded={isExpanded}
        onToggleExpanded={() => setIsExpanded(!isExpanded)}
        onClose={handleClose}
      />
    </div>
  );
};

export default Player;
